// import { Test } from '@ui/UiComponents'
import { ElementContext } from 'global/cnr/contexts/ElementContext'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Label, Icon, Menu } from 'semantic-ui-react'
// import { Icon, Label } from 'src/global/components/ui/UiComponents'

// import { Label, Icon } from '@ui/UiComponents'
// import { Label, Icon } from '../../ui/UiComponents';

const _icons = {
  charter: 'plane',
  dropOff: 'eyedropper',
  hotel: 'hotel',
  rentalCar: 'taxi',
  checkIn: 'sign in alternate',
  checkOut: 'sign out alternate',
  game: 'hashtag'
}
export const CardHotelInfo = () => {

  const elementContext = useContext(ElementContext)
  const { element_state } = elementContext ?? {}
  const { itemData } = element_state ?? {}

  const groupAttendeesByNumber = useMemo(() => {
    const grouped = {};

    _.forEach(itemData, (value, propKey) => {
      const match = propKey.match(/(checkIn|checkOut|game|hotel|charter|rentalCar|dropOff)(\d+)/);
      if (match) {
        const [, baseKey, number] = match;
        if (!grouped[number]) grouped[number] = {};
        grouped[number][baseKey] = value;
      }
    });

    return grouped;
  }, [itemData]);

  const lbls = _.map(groupAttendeesByNumber, (item, itemNumber) => {
    const { checkIn, checkOut, game, charter, hotel, rentalCar, dropOff } = item
    return <div style={{ display: 'flex', gap: '.5em', marginBottom: '.5em', flexDirection: 'column' }}>
      <Label >{'Game ' + itemNumber}</Label>
      <div style={{ display: 'flex', gap: '.5em', flexDirection: 'row' }}>
        <div><Icon name='taxi' circular color={rentalCar ? 'green' : 'grey'}></Icon></div>
        <div><Icon name='plane' circular color={charter ? 'green' : 'grey'}></Icon></div>
        <div><Icon name='eyedropper' circular color={dropOff ? 'green' : 'grey'}></Icon></div>
        <div style={{ display: 'flex', gap: '.5em' }}><Icon name='hotel' circular color={hotel ? 'green' : 'grey'}></Icon>
          {hotel && <Label color='green'>{checkIn ? checkIn : '---'}</Label>}
          {hotel && <Label color='red'>{checkOut ? checkOut : '---'}</Label>}
        </div>
      </div>
    </div>
  })

  return (
    <div>{lbls}</div>
  )
}

const CardHotelInfos = () => {

  const parentContent = useContext(ParentContext)
  const { states } = parentContent ?? {}
  const attendees = _.get(states, 'eventInfo_state.appDataDocuments.attendees')

  const [attendeesList, setAttendeesList] = useState()
  const [activeAttendeesList, setActiveAttendeesList] = useState()
  const [activeAttendees, setActiveAttendees] = useState()
  const [selectedDay, setSelectedDay] = useState()
  const [selectedItem, setSelectedItem] = useState()

  const handleSelectedDay = (e, key) => {
    setSelectedDay(key)
    if (attendeesList?.[key]) {
      setActiveAttendeesList(attendeesList?.[key])
    }
  }

  const handleSelectedItem = (e, key) => {
    setSelectedItem(key)
  }

  const attendeesByNumber = useMemo(() => {
    const result = {};

    _.forEach(attendees, (attendee) => {
      _.forEach(attendee, (value, propKey) => {
        const match = propKey.match(/(checkIn|checkOut|game|hotel|charter|rentalCar|dropOff)(\d+)/);
        if (match) {
          const [, baseKey, number] = match;

          if (!result[number]) {
            result[number] = {};
          }

          if (!result[number][baseKey]) {
            result[number][baseKey] = [];
          }

          result[number][baseKey].push(attendee);
        }
      });
    });
    return result;
  }, [attendees]);

  const topMenu = useMemo(() => {
    const mis = attendeesList ? _.map(attendeesList, (abn, key) => {
      const selected = selectedDay === key
      return <Menu.Item active={selected} onClick={(e) => { handleSelectedDay(e, key) }}>{key}</Menu.Item>
    }) : []
    return <Menu size='mini'>{mis}</Menu>
  }, [selectedDay, attendeesByNumber])

  const selectedMenu = useMemo(() => {
    const mis = activeAttendeesList ? _.map(activeAttendeesList, (abn, key) => {
      const selected = selectedItem === key
      return <Menu.Item active={selected} onClick={(e) => { handleSelectedItem(e, key) }}>{_.startCase(key)}</Menu.Item>
    }) : []
    return <Menu size='mini'>{mis}</Menu>
  }, [activeAttendeesList, selectedItem])

  const selectedXXX = useMemo(() => {
    const _activeAttendeesList = activeAttendeesList?.[selectedItem]
    console.log('_activeAttendeesList', _activeAttendeesList)
    setActiveAttendees(_activeAttendeesList)
  }, [selectedDay, selectedItem])

  useEffect(() => {
    setAttendeesList(attendeesByNumber)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedItem]);

  const groupByNumber = (attendee) => {
    const grouped = {};
    _.forEach(attendee, (value, propKey) => {
      // const regex = new RegExp(`${_match}(\\d+)`); 
      // const regex = new RegExp(`${selectedItem}(\\d+)`);
      // const match = propKey.match(regex);
      // console.log('match', match)
      // console.log('match', match)
      const match = propKey.match(/(checkIn|checkOut|game|hotel|charter|rentalCar|dropOff)(\d+)/);
      if (match) {
        const [baseKey, number] = match;
        if (!grouped[number]) grouped[number] = {};
        grouped[number][baseKey] = value;
      }
    });
    return grouped;
  };

  const lbls = (gbn) => _.map(gbn, (item, itemNumber) => {
    const lbls = []
    _.forEach(item, (itemValue, itemKey) => {
      if (itemKey.startsWith(selectedItem) && itemKey.endsWith(selectedDay)) {
        lbls.push(<div><Icon name={_icons[selectedItem] ? _icons[selectedItem] : 'cog'} circular color={itemValue ? 'green' : 'grey'}></Icon></div>)

      }
    })
    return lbls
  })

  const allLabeles = useMemo(() => {
    if (activeAttendees) {
      const allAttendees = _.map(activeAttendees, (attendee) => {
        const { lastName, firstName } = attendee
        const gbn = groupByNumber(attendee)
        const _lbls = lbls(gbn)
        return <div style={{ padding: '0 .5em', display: 'flex', alignItems: 'center', gap: '1em', justifyContent: 'space-between' }}><div>{firstName}{' '}{lastName}</div><div>{_lbls}</div></div>
      })
      return allAttendees
    }
  }, [activeAttendees, selectedItem])

  return (
    <div>
      {topMenu}
      {selectedMenu}
      {allLabeles}
    </div>
    // <div>{allLabeles}</div>
  )
}

export default CardHotelInfos
